
import  {
    faCaretUp,
    faExpand,
    faCompress,
    faMagnifyingGlassPlus,
    faMagnifyingGlassMinus
} from "@awesome.me/kit-5f107d6f8b/icons/sharp/solid";

const sharpSolid = {
    faCaretUp,
    faExpand,
    faCompress,
    faMagnifyingGlassPlus,
    faMagnifyingGlassMinus
};

export {
    sharpSolid,
};
